<script>
	import { slide } from "svelte/transition"

	let isOpen = false
	const toggle = () => isOpen = !isOpen
</script>

<div class="noticeTitle">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 56" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M76.7271 15.3062L76.7795 15.3559H15.356L15.356 55.1094L7.62939e-05 38.9453V15.3559H0V0H60.6154L72.1943 11H145.294L150 15.3062H76.7271Z" fill="#7A67FF"/>
    </svg>

    <div class="title" class:active={isOpen} on:click={toggle} aria-expanded={isOpen}>
        공지사항
        (2025.05.12)
        
        {#if isOpen}
            [접기]
        {:else}
            [펼치기]
        {/if}
    </div>
</div>

<div class="notice">
    {#if isOpen}
        <ul transition:slide={{ duration: 300 }}>
            <li>서버 이동 및 재오픈</li>
        </ul>
    {/if}
</div>

<style lang="scss">
    .noticeTitle {
        width: calc(100% - 16px);
        max-width: 1200px;
        height: fit-content;
        margin: 0 auto;
        padding: 16px 0px 0px 16px;

        position: relative;

        svg {
            fill: none;
            position: absolute;

            width: 150px;
            height: 56px;
            top: 16px;
            left: 16px;
            z-index: 1;
        }
        
        .title {
            width: fit-content;
            padding-top: calc(16px + 10px);
            padding-left: calc(16px + 22px);
            font-family: aggro;
            opacity: 1.0;
            position: relative;
            cursor: pointer;
            
            &.active {
                opacity: 1.0;
            }
        }

    }

    .notice {
        width: calc(100% - 32px);
        height: fit-content;
        margin-bottom: 50px;
        padding: 0px 16px;

        ul {
            background: rgba($color: $cl3, $alpha: 0.3);
            margin: 0;
            margin-top: 30px;

            li {
                margin-top: 5px;
                word-break: keep-all;

                strong {
                    background-color: $cl6;
                    padding: 4px;
                    border-radius: $br1;
                    color: $cl4;
                    font-family: blade;
                }

                a {
                    padding: 4px;
                    border-radius: $br1;
                    color: $cl6;
                    font-family: blade;

                    &:hover {
                        background: $cl6;
                        color: $cl4;
                    }
                }
            }
        }
    }

    @include mobile {
        .noticeTitle {
            .title {
                font-size: 20px;
            }
        }
        
        .notice {
            ul {
                padding: 10px;
                padding-left: calc(10px + 40px);
                font-size: 12px;
            }
        }
    }

    @include tablet {
        .noticeTitle {
            .title {
                font-size: 25px;
            }
        }
        
        .notice {
            ul {
                padding: 20px;
                padding-left: calc(20px + 40px);
                font-size: 16px;
            }
        }
    }

    @include desktop {
        .noticeTitle {
            .title {
                font-size: 30px;
            }
        }
        
        .notice {
            ul {
                padding: 20px;
                padding-left: calc(20px + 40px);
                font-size: 16px;
            }
        }
    }

    @include wide {
        .noticeTitle {
            .title {
                font-size: 30px;
            }
        }
        
        .notice {
            ul {
                padding: 20px;
                padding-left: calc(20px + 40px);
                font-size: 16px;
            }
        }
    }
</style>